import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const animationSelectors = [
  '.block-hero__slider-content',
  '.block-lead-intro',
  '.block-content-image',
  '.block-content-image__inner',
  '.block-showcase',
  '.block-showcase__items',
  '.block-hero__content',
  '.block-features',
  '.block-cta-hero__inner',
  '.block-gallery',
  '.block-posts',
  '.single-product-page__inner',
  '.single-product-page__featured-projects',
  '.single-product-page__featured-projects-items',
  '.single-product-page__related',
  '.single-product-page__related-items',
  '.project__hero',
  '.project__body',
  '.block-single-media',
  '.team-members',
  '.team-members__wrapper',
  '.team-members__items',
  '.block-columns-content',
  '.block-columns-content__items',
  '.block-careers',
  '.block-showrooms',
  '.block-showrooms__items',
  '.block-form',
  '.block-form__inner',
  '.block-regional-booking-contacts__item',
  '.block-cta-blocks',
  '.block-steps',
  '.block-steps__items',
  '.block-faq',
  '.block-product-sections',
  '.block-product-sections__section'
];

animationSelectors.forEach(parent => {
  const parentElement = document.querySelectorAll(parent);

  if (parentElement) {
    parentElement.forEach(p => {
      const childElements = p.querySelectorAll(`:scope > *`);

      gsap.to(childElements, {
        y: 'none',
        opacity: 1,
        duration: .5,
        stagger: 0.3,
        scrollTrigger: {
          trigger: p,
          // start: 'top bottom-=100',
          // end: 'top center',
          toggleActions: 'play none none none',
          // markers: true,
        },
      });
    })

  }
});
